// @mui material components
import {
  Snackbar,
  Alert,
  Grid,
  Card,
  Icon,
  CircularProgress,
  // LinearProgress,
  Backdrop,
  Table,
  // TableHead,
  TableContainer,
  TableCell,
  TableBody,
  TableRow,
  Paper,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  // Stack,
} from "@mui/material";

// Material Dashboard 2 React components
import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";

// Material Dashboard 2 React example components
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";

import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios.js";
// import DataTable from "theme/Tables/DataTable";
import MDButton from "theme/components/MDButton";
import MDBadge from "theme/components/MDBadge";
import MDInput from "theme/components/MDInput";

import { PinInput } from "react-input-pin-code";
import usePageTitle from "app/pageTitle";
import ApiConfig from "apiConfig";
import P2PRequestHeader from "../../header";

function UserSwap() {
  const pageTitle = "Swap Transaction";
  usePageTitle(pageTitle);

  const { reference } = useParams();

  const [refreshPage, setRefreshPage] = useState(false);
  const [refreshStarted, setRefreshStarted] = useState(null);
  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("error");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };

  const [openCancelDialog, setCancelDialog] = useState(false);
  const [openConfirmPaymentDialog, setConfirmPaymentDialog] = useState(false);
  const [openBuyerConfirmationDialog, setOpenBuyerConfirmationDialog] = useState(false);

  const [swap, setSwap] = useState(null);
  const [counterSwap, setCounterSwap] = useState({});
  const [paymentDetails, setPaymentDetails] = useState({});
  const [buyerDetails, setBuyerDetails] = useState([]);

  const [userSecurePin, setUserSecurePin] = useState(null);
  const [pinValues, setPinValues] = useState(["", "", "", ""]);

  function formatAmount(amt, symbol) {
    if (amt > 1) {
      return `${symbol}${amt.toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}`;
    }
    return `${symbol}${amt}`;
  }

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get(`ewallets/user/swaps/${reference}/get.json`)
        .then((result) => {
          // console.log(result);
          setShowLoading(false);
          if (result.data.status === "success") {
            setSwap(result.data.data.swap);
            setCounterSwap(result.data.data.counter_swap);
            result.data.data.swap.digital_wallet.verification_parameters.every((param) => {
              paymentDetails[param.key] = "";
              setPaymentDetails(paymentDetails);
              return true;
            });
            setBuyerDetails(
              result.data.data.swap.digital_wallet.p2p_automated
                ? result.data.data.swap.digital_wallet.p2p_automated_details
                : result.data.data.swap.wallet_destination
            );
            if (result.data.data.swap.closed === false) {
              if (refreshStarted !== null) {
                clearInterval(refreshStarted);
              }
              const id = setInterval(() => setRefreshPage(!refreshPage), 30000);
              setRefreshStarted(id);
            }
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg("An error occurred. Please try again later.");
          setOpen(true);
        });
    };

    fetchData();
  }, [refreshPage]);

  async function cancelOrder() {
    setShowLoading(true);
    await axios
      .post("ewallets/user/swaps/decline.json", { reference: `${reference}` })
      .then((result) => {
        // console.log(result);
        setShowLoading(false);
        if (result.data.status === "success") {
          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg("An error occurred. Please try again later.");
        setOpen(true);
      });
  }

  async function confirmPayment() {
    setShowLoading(true);
    await axios
      .post("ewallets/user/swaps/payment.json", {
        reference: `${reference}`,
        confirmation: paymentDetails,
      })
      .then((result) => {
        // console.log(result);
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);
          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg("An error occurred. Please try again later.");
        setOpen(true);
      });
  }

  async function confirmPaymentBuyer() {
    if (userSecurePin === null) {
      setSeverity("error");
      setErrMsg("Please enter your secure pin.");
      setOpen(true);
      return;
    }

    setShowLoading(true);
    await axios
      .post("ewallets/user/swaps/payment/buyer.json", {
        reference: `${reference}`,
        pin: `${userSecurePin}`,
      })
      .then((result) => {
        // console.log(result);
        setShowLoading(false);
        if (result.data.status === "success") {
          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg("An error occurred. Please try again later.");
        setOpen(true);
      });
  }

  function getStatusColor(stat) {
    let statusColor = "warning";
    if (stat.toUpperCase() === "COMPLETED") {
      statusColor = "success";
    } else if (stat.toUpperCase() === "SELLER-DECLINED") {
      statusColor = "dark";
    } else if (stat.toUpperCase() === "ERROR") {
      statusColor = "error";
    } else if (stat.toUpperCase() === "FAILED") {
      statusColor = "error";
    } else if (stat.toUpperCase() === "AWAITING-SELLER-PAYMENT") {
      statusColor = "info";
    } else {
      statusColor = "warning";
    }

    return statusColor;
  }

  //   function setVerificationDetails(key, value) {
  //     paymentDetails[key] = value;
  //     setPaymentDetails(paymentDetails);
  //   }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      <Dialog open={openCancelDialog}>
        <DialogTitle>
          <MDBox>Decline Swap?</MDBox>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <MDBox>Are you sure you want to decline this swap?</MDBox>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setCancelDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            No
          </MDButton>
          <MDButton
            color="warning"
            variant="outlined"
            onClick={() => {
              setCancelDialog(false);
              cancelOrder();
            }}
          >
            Yes
          </MDButton>
        </DialogActions>
      </Dialog>
      {swap !== null ? (
        <>
          <Dialog open={openConfirmPaymentDialog}>
            <DialogTitle>
              <MDBox>Confirm Payment</MDBox>
            </DialogTitle>
            <DialogContent>
              <DialogContentText>
                <MDTypography variant="text" fontWeight="light">
                  Please enter the following details of payment made to buyer below.
                </MDTypography>
              </DialogContentText>
              <MDBox>
                {swap.digital_wallet.verification_parameters.map((param) => (
                  <MDBox mt={4}>
                    <MDInput
                      // value={paymentDetails[param.key]}
                      onChange={(e) => {
                        // setVerificationDetails(param.key, e.target.value);
                        paymentDetails[param.key] = e.target.value;
                        setPaymentDetails(paymentDetails);
                      }}
                      name={param.key}
                      label={param.display_name}
                      sx={{ minWidth: 120, width: "100%" }}
                    />
                  </MDBox>
                ))}
              </MDBox>
            </DialogContent>
            <DialogActions>
              <MDButton
                onClick={() => {
                  setConfirmPaymentDialog(false);
                }}
                color="dark"
                variant="outlined"
              >
                Not Yet
              </MDButton>
              <MDButton
                color="success"
                variant="outlined"
                onClick={() => {
                  setConfirmPaymentDialog(false);
                  confirmPayment();
                }}
              >
                I have paid
              </MDButton>
            </DialogActions>
          </Dialog>

          <Dialog open={openBuyerConfirmationDialog}>
            <DialogTitle>
              <MDBox>Confirm Seller&apos;s Payment?</MDBox>
            </DialogTitle>
            <DialogContent>
              <DialogContentText>
                <MDBox>
                  Make sure you have received funds in your {swap.digital_wallet.title} account
                  before confirming payment. You can confirm using the <b>Transaction Code</b> in
                  the payment narration. This action cannot be reversed!
                </MDBox>
              </DialogContentText>
              <MDBox mt={4}>
                <MDTypography variant="h6">Enter your secure pin</MDTypography>
                <MDBox mt={1}>
                  <PinInput
                    values={pinValues}
                    onChange={(value, index, values) => setPinValues(values)}
                    length={4}
                    mask
                    autoTab
                    placeholder="-"
                    onComplete={(text) => {
                      let up = "";
                      text.forEach((itm) => {
                        up += itm;
                      });
                      setUserSecurePin(up);
                    }}
                  />
                </MDBox>
              </MDBox>
            </DialogContent>
            <DialogActions>
              <MDButton
                onClick={() => {
                  setOpenBuyerConfirmationDialog(false);
                }}
                color="dark"
                variant="contained"
              >
                Maybe not
              </MDButton>
              <MDButton
                color="success"
                variant="contained"
                onClick={() => {
                  if (userSecurePin === null) {
                    return;
                  }
                  setOpenBuyerConfirmationDialog(false);
                  confirmPaymentBuyer();
                }}
              >
                Yes, I have received funds
              </MDButton>
            </DialogActions>
          </Dialog>
        </>
      ) : (
        <> </>
      )}

      <MDBox pt={3} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Grid container spacing={3}>
              <P2PRequestHeader />
            </Grid>
            <Grid
              container
              spacing={3}
              display="flex"
              alignItems="center"
              justifyContent="space-evenly"
            >
              <Grid item xs={12} md={9} lg={9}>
                <MDBox>
                  <Card sx={{ height: "100%", marginTop: "0px" }}>
                    <MDBox p={0}>
                      <MDBox p={3} display="flex" justifyContent="space-between" mb={1}>
                        <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize">
                          Swap Transaction
                        </MDTypography>
                        {swap !== null ? (
                          <MDBadge
                            badgeContent={swap.status}
                            variant="contained"
                            container
                            color={getStatusColor(swap.status)}
                          />
                        ) : (
                          <MDBadge badgeContent="---" variant="contained" container color="dark" />
                        )}
                      </MDBox>
                      <MDBox sx={{ textAlign: "center" }} pr={3} mb={5}>
                        {swap === null ? (
                          <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize">
                            ---
                          </MDTypography>
                        ) : (
                          <MDTypography variant="h6" fontWeight="light">
                            {swap.status_message}
                          </MDTypography>
                        )}
                      </MDBox>
                      <MDBox mt={1}>
                        <TableContainer component={Paper}>
                          <Table aria-label="simple table">
                            {swap === null ? (
                              <TableBody>
                                <TableRow
                                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                                >
                                  <TableCell component="th" scope="row">
                                    No data
                                  </TableCell>
                                  <TableCell align="right">received</TableCell>
                                </TableRow>
                              </TableBody>
                            ) : (
                              <TableBody>
                                <TableRow
                                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                                >
                                  <TableCell component="th" scope="row">
                                    <MDTypography variant="h6" fontWeight="light">
                                      Reference
                                    </MDTypography>
                                  </TableCell>
                                  <TableCell align="right">
                                    <MDTypography variant="h6" fontWeight="medium">
                                      {swap.reference}
                                    </MDTypography>
                                  </TableCell>
                                </TableRow>
                                <TableRow
                                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                                >
                                  <TableCell component="th" scope="row">
                                    <MDTypography variant="h6" fontWeight="light">
                                      Digital Wallet
                                    </MDTypography>
                                  </TableCell>
                                  <TableCell align="right">
                                    <MDBox
                                      display="flex"
                                      alignItems="center"
                                      justifyContent="right"
                                    >
                                      <img
                                        alt=""
                                        src={`${ApiConfig.api_media_url}${swap.digital_wallet.logo}`}
                                        width="25"
                                      />
                                      <MDBox ml={2}>
                                        <MDTypography variant="h6" fontWeight="medium">
                                          {swap.digital_wallet.title}
                                        </MDTypography>
                                      </MDBox>
                                    </MDBox>
                                  </TableCell>
                                </TableRow>
                                <TableRow
                                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                                >
                                  <TableCell component="th" scope="row">
                                    <MDTypography variant="h6" fontWeight="light">
                                      Currency Pair
                                    </MDTypography>
                                  </TableCell>
                                  <TableCell align="right">
                                    <MDTypography variant="h6" fontWeight="medium" ml={1}>
                                      {swap.side === "BUY" ? (
                                        <>
                                          {" "}
                                          {swap.balance_currency.currency_code} /{" "}
                                          {swap.wallet_currency.currency_code}
                                        </>
                                      ) : (
                                        <>
                                          {swap.wallet_currency.currency_code} /{" "}
                                          {swap.balance_currency.currency_code}{" "}
                                        </>
                                      )}
                                    </MDTypography>
                                  </TableCell>
                                </TableRow>
                                <TableRow
                                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                                >
                                  <TableCell component="th" scope="row">
                                    <MDTypography variant="h6" fontWeight="light">
                                      Type
                                    </MDTypography>
                                  </TableCell>
                                  <TableCell align="right">
                                    <MDBadge
                                      badgeContent={swap.side}
                                      variant="contained"
                                      container
                                      color={swap.side === "SELL" ? "error" : "success"}
                                    />
                                  </TableCell>
                                </TableRow>
                                <TableRow
                                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                                >
                                  <TableCell component="th" scope="row">
                                    <MDTypography variant="h6" fontWeight="light">
                                      Amount
                                    </MDTypography>
                                  </TableCell>
                                  <TableCell align="right">
                                    <MDTypography variant="h6" fontWeight="medium">
                                      {formatAmount(
                                        swap.amount / swap.wallet_currency.multiplier,
                                        swap.wallet_currency.symbol
                                      )}
                                    </MDTypography>
                                  </TableCell>
                                </TableRow>
                                <TableRow
                                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                                >
                                  <TableCell component="th" scope="row">
                                    <MDTypography variant="h6" fontWeight="light">
                                      Exchange Rate
                                    </MDTypography>
                                  </TableCell>
                                  <TableCell align="right">
                                    <MDTypography variant="h6" fontWeight="medium">
                                      {formatAmount(
                                        swap.exchange_rate / swap.wallet_currency.multiplier,
                                        swap.balance_currency.symbol
                                      )}{" "}
                                      / {swap.wallet_currency.symbol}1
                                    </MDTypography>
                                  </TableCell>
                                </TableRow>
                                <TableRow
                                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                                >
                                  <TableCell component="th" scope="row">
                                    <MDTypography variant="h6" fontWeight="light">
                                      Transaction Fee
                                    </MDTypography>
                                  </TableCell>
                                  <TableCell align="right">
                                    <MDTypography variant="h6" fontWeight="medium">
                                      {formatAmount(
                                        swap.transaction_fee / swap.balance_currency.multiplier,
                                        swap.balance_currency.symbol
                                      )}
                                    </MDTypography>
                                  </TableCell>
                                </TableRow>
                                <TableRow
                                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                                >
                                  <TableCell component="th" scope="row">
                                    <MDTypography variant="h6" fontWeight="light">
                                      Peer Commission
                                    </MDTypography>
                                  </TableCell>
                                  <TableCell align="right">
                                    <MDTypography variant="h6" fontWeight="medium">
                                      {formatAmount(
                                        swap.commission / swap.balance_currency.multiplier,
                                        swap.balance_currency.symbol
                                      )}
                                    </MDTypography>
                                  </TableCell>
                                </TableRow>
                                <TableRow
                                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                                >
                                  <TableCell component="th" scope="row">
                                    <MDTypography variant="h6" fontWeight="light">
                                      {swap.side === "BUY" ? "You Pay" : "You Get"}
                                    </MDTypography>
                                  </TableCell>
                                  <TableCell align="right">
                                    <MDTypography variant="h6" fontWeight="medium">
                                      {formatAmount(
                                        swap.fiat_amount / swap.wallet_currency.multiplier,
                                        swap.balance_currency.symbol
                                      )}
                                    </MDTypography>
                                  </TableCell>
                                </TableRow>
                                <TableRow
                                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                                >
                                  <TableCell component="th" scope="row">
                                    <MDTypography variant="h6" fontWeight="light">
                                      Status
                                    </MDTypography>
                                  </TableCell>
                                  <TableCell align="right">
                                    <MDTypography variant="h6" fontWeight="light">
                                      {swap.closed ? "Closed" : "Open"}
                                    </MDTypography>
                                  </TableCell>
                                </TableRow>
                                <TableRow
                                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                                >
                                  <TableCell component="th" scope="row">
                                    <MDTypography variant="h6" fontWeight="light">
                                      Status Message
                                    </MDTypography>
                                  </TableCell>
                                  <TableCell align="right">
                                    <MDTypography variant="h6" fontWeight="light">
                                      {swap.status_message}
                                    </MDTypography>
                                  </TableCell>
                                </TableRow>
                                <TableRow
                                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                                >
                                  <TableCell component="th" scope="row">
                                    <MDTypography variant="h6" fontWeight="light">
                                      Initiated On
                                    </MDTypography>
                                  </TableCell>
                                  <TableCell align="right">
                                    <MDTypography variant="h6" fontWeight="light">
                                      {swap.created}
                                    </MDTypography>
                                  </TableCell>
                                </TableRow>
                              </TableBody>
                            )}
                          </Table>
                        </TableContainer>
                      </MDBox>
                    </MDBox>
                  </Card>
                </MDBox>
                <MDBox mt={3}>
                  <Card sx={{ height: "100%", marginTop: "0px" }}>
                    <MDBox p={0}>
                      <MDBox p={3} display="flex" justifyContent="space-between" mb={1}>
                        <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize">
                          Payment Information
                        </MDTypography>
                      </MDBox>
                      <MDBox mt={1}>
                        <TableContainer component={Paper}>
                          <Table aria-label="simple table">
                            {swap === null ? (
                              <TableBody>
                                <TableRow
                                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                                >
                                  <TableCell component="th" scope="row">
                                    No data
                                  </TableCell>
                                  <TableCell align="right">received</TableCell>
                                </TableRow>
                              </TableBody>
                            ) : (
                              <TableBody>
                                {swap.side === "SELL" ? (
                                  <>
                                    <TableRow
                                      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                                    >
                                      <TableCell component="th" scope="row">
                                        <MDTypography variant="h6" fontWeight="light">
                                          Transaction Code
                                        </MDTypography>
                                      </TableCell>
                                      <TableCell align="right">
                                        <MDTypography variant="text">
                                          <b>{swap.reference}</b>
                                          &nbsp;
                                          <Icon
                                            onClick={() => {
                                              navigator.clipboard.writeText(counterSwap.reference);
                                              setSeverity("success");
                                              setErrMsg(`Transaction code copied!`);
                                              setOpen(true);
                                            }}
                                          >
                                            copy
                                          </Icon>
                                        </MDTypography>
                                      </TableCell>
                                    </TableRow>
                                    <TableRow
                                      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                                    >
                                      <TableCell component="th" scope="row">
                                        <MDTypography variant="h6" fontWeight="light">
                                          Payment Instructions
                                        </MDTypography>
                                      </TableCell>
                                      <TableCell align="right">
                                        <MDTypography variant="text" fontWeight="light">
                                          {swap.payment_instruction_object.instructions}
                                        </MDTypography>
                                      </TableCell>
                                    </TableRow>
                                    <TableRow
                                      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                                    >
                                      <TableCell component="th" scope="row">
                                        <MDTypography variant="h6" fontWeight="light">
                                          {swap.payment_instruction_object.type === "redirect" ? (
                                            <>{swap.digital_wallet.title} Invoice</>
                                          ) : (
                                            <> Pay To:</>
                                          )}
                                        </MDTypography>
                                      </TableCell>
                                      <TableCell align="right">
                                        {swap.payment_instruction_object.type === "redirect" ? (
                                          <MDButton
                                            variant="outlined"
                                            color="dark"
                                            size="medium"
                                            onClick={() =>
                                              window.open(
                                                swap.payment_instruction_object.data.redirect_url,
                                                "_blank"
                                              )
                                            }
                                          >
                                            <MDBox
                                              display="flex"
                                              alignItems="center"
                                              justifyContent="left"
                                            >
                                              <img
                                                alt=""
                                                src={`${ApiConfig.api_media_url}${swap.digital_wallet.logo}`}
                                                width="20"
                                                mr={3}
                                              />
                                              <MDBox ml={2}>Pay Now</MDBox>
                                            </MDBox>
                                          </MDButton>
                                        ) : (
                                          <MDTypography variant="h6" fontWeight="light">
                                            {buyerDetails.map((detail) => (
                                              <MDBox mb={1}>
                                                <MDTypography variant="text">
                                                  <b>{detail.display_name}</b>: {detail.value}
                                                  &nbsp;
                                                  <Icon
                                                    onClick={() => {
                                                      navigator.clipboard.writeText(detail.value);
                                                      const wrd = detail.display_name;
                                                      setSeverity("success");
                                                      setErrMsg(`${wrd} copied!`);
                                                      setOpen(true);
                                                    }}
                                                  >
                                                    copy
                                                  </Icon>
                                                </MDTypography>
                                              </MDBox>
                                            ))}
                                          </MDTypography>
                                        )}
                                      </TableCell>
                                    </TableRow>
                                  </>
                                ) : (
                                  <>
                                    <TableRow
                                      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                                    >
                                      <TableCell component="th" scope="row">
                                        <MDTypography variant="h6" fontWeight="light">
                                          Transaction Code
                                        </MDTypography>
                                      </TableCell>
                                      <TableCell align="right">
                                        <MDTypography variant="text">
                                          <b>{swap.reference}</b>
                                          &nbsp;
                                          <Icon
                                            onClick={() => {
                                              navigator.clipboard.writeText(counterSwap.reference);
                                              setSeverity("success");
                                              setErrMsg(`Transaction code copied!`);
                                              setOpen(true);
                                            }}
                                          >
                                            copy
                                          </Icon>
                                        </MDTypography>
                                      </TableCell>
                                    </TableRow>
                                    <TableRow
                                      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                                    >
                                      <TableCell component="th" scope="row">
                                        <MDTypography variant="h6" fontWeight="light">
                                          Your {swap.digital_wallet.title} Details
                                        </MDTypography>
                                      </TableCell>
                                      <TableCell align="right">
                                        <MDTypography variant="h6" fontWeight="light">
                                          {swap.wallet_destination.map((detail) => (
                                            <MDBox mb={1}>
                                              <MDTypography variant="text">
                                                <b>{detail.display_name}</b>: {detail.value}
                                              </MDTypography>
                                            </MDBox>
                                          ))}
                                        </MDTypography>
                                      </TableCell>
                                    </TableRow>
                                  </>
                                )}
                                {!swap.closed ? (
                                  <TableRow>
                                    {swap.side === "SELL" ? (
                                      <TableCell colSpan={2}>
                                        <MDBox
                                          sx={{ textAlign: "center" }}
                                          p={3}
                                          display="flex"
                                          alignItems="center"
                                          justifyContent="space-evenly"
                                        >
                                          <MDButton
                                            variant="outlined"
                                            color="error"
                                            onClick={() => {
                                              setCancelDialog(true);
                                            }}
                                          >
                                            <Icon>close</Icon>&nbsp; Decline this Swap
                                          </MDButton>
                                          {swap.digital_wallet.p2p_automated &&
                                          swap.digital_wallet.p2p_automation_type !== "INV" ? (
                                            <MDButton
                                              variant="outlined"
                                              color="success"
                                              onClick={() => {
                                                setConfirmPaymentDialog(true);
                                              }}
                                            >
                                              <Icon>check</Icon>&nbsp; I have paid to buyer&apos;s{" "}
                                              {swap.digital_wallet.title} account
                                            </MDButton>
                                          ) : (
                                            <> </>
                                          )}
                                        </MDBox>
                                      </TableCell>
                                    ) : (
                                      <TableCell colSpan={2}>
                                        <MDBox
                                          sx={{ textAlign: "center" }}
                                          p={3}
                                          display="flex"
                                          alignItems="center"
                                          justifyContent="space-evenly"
                                        >
                                          <MDButton
                                            variant="outlined"
                                            color="success"
                                            onClick={() => {
                                              setPinValues(["", "", "", ""]);
                                              setOpenBuyerConfirmationDialog(true);
                                            }}
                                          >
                                            <Icon>check</Icon>&nbsp; I have received funds from
                                            seller
                                          </MDButton>
                                        </MDBox>
                                      </TableCell>
                                    )}
                                  </TableRow>
                                ) : (
                                  <> </>
                                )}
                              </TableBody>
                            )}
                          </Table>
                        </TableContainer>
                      </MDBox>
                    </MDBox>
                  </Card>
                </MDBox>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default UserSwap;
